import { topupStatuses, TOPUP_STATUS_CONSTANTS } from "Helpers/options";

const { ON_PROGRESS, PENDING, SUCCESS } = TOPUP_STATUS_CONSTANTS;
const topupStatus = (value) => {
  const selectedTopupStatus = getTopupStatus(value);
  let badgeColor = "";
  switch (selectedTopupStatus?.value) {
    case ON_PROGRESS:
    case PENDING:
      badgeColor = "badge badge-soft-dark";
      break;
    case SUCCESS:
      badgeColor = "badge badge-soft-success";
      break;
    default:
      badgeColor = "badge badge-soft-danger";
      break;
  }
  return <span className={badgeColor}>{selectedTopupStatus?.label}</span>;
};

const getTopupStatus = (value) => {
  return topupStatuses.find((opt) => opt.value === value);
};

export { topupStatus, getTopupStatus };
